<template>
  <div style="display:inline-block">
    <div class="spaceLeft auth-status" :class="'status'+status">
      <img v-if="+status == 2" src="@/assets/image/auth/passed.png" />
      <img v-else-if="+status == 3" src="@/assets/image/auth/notpassed.png" />
      <img v-else-if="+status == 1" src="@/assets/image/auth/ing.png" />
      <img v-else src="@/assets/image/auth/passed.png" />
      <span>{{ status | dictFilter($store.getters.producerAuthSatatus) }}</span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: [Number, String],
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="scss">
.auth-status {
  background: #E9EBEF;
  border-radius: 0.16rem;
  padding: 0 0.1rem;
  height: 0.32rem;
  line-height: 0.32rem;
  font-size: 0.18rem;
  color:#929DAD;
  img{
    height: 0.22rem;margin-right: 0.08rem;
  }

  &.status1{
    background: #FDE3E9;
    color:#F0426C;
  }
  &.status2{
    background: #ECF9DE;
    color:#7ED321;
  }
  &.status3{
    background: #E9EBEF;
    color:#929DAD;
  }
}
</style>
